/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  createDialogRoute,
  FormState,
  FormStateBuilder,
} from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import {
  AutocompleteLoadMoreEvent,
  DialogInput, NotificationService,
} from '@gh/core-ui';
import { map$ } from '@gh/rx/operators';
import { HlpListItemDto, HlpRestService, QuotationListItemDto } from '@gh/builder-shared-data';
import { composeComparators, negateComparator, valueComparator } from '@gh/core-util';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { Observable } from 'rxjs';
export type CloneQuote = QuotationListItemDto;
export type HlpListItem = HlpListItemDto & {
  masterZoneId?: ID;
  officeId?: ID;
};
export const getCloneQuoteId = (quote: CloneQuote) => quote.id;
export const cloneQuoteComparator = composeComparators(
  negateComparator(valueComparator('code')),
  valueComparator(getCloneQuoteId));
export enum HlpQuoteCloneDialogEntryPoint {
  CloneQuote,
}

export interface HlpQuoteCloneDataDialogConfig {
  entryPoint: HlpQuoteCloneDialogEntryPoint;
  priceBookId?: ID;
}

@Component({
  selector:    'gh-hlp-quote-clone-data-dialog',
  template: require('./hlp-quote-clone-data-dialog.component.html'),
  styles:   [require('./hlp-quote-clone-data-dialog.component.scss')],
})
export class HlpQuoteCloneDataDialogComponent implements OnInit, DialogInput<HlpQuoteCloneDataDialogConfig> {
  input: HlpQuoteCloneDataDialogConfig;
  form: FormState<any>;

  get title(): string {
    return 'lbl_hlp_clone_quote_changes';
  }

  constructor(
    private dialogRef: MatDialogRef<any>,
    private formStateBuilder: FormStateBuilder,
    private notificationService: NotificationService,
    private hlpRest: HlpRestService,
    ) {

  }

  ngOnInit(): void {
    this.form = this.formStateBuilder.buildPlain({
      value:    {
        hlp:     '',
      },
      children: {
        hlp:     { required: true },
      },
    });
  }

  loadHlp(event: AutocompleteLoadMoreEvent): void {
    const filter = this.input.priceBookId ? {
      priceBookId: this.input.priceBookId,
      searchInSiteAddress: false,
      showPublished: true,
      showDraft: true,
    } : {};
    event.load(this.findHlpByNumberDescription(event.query, filter)
      .pipe(map$((resp) => resp.map((hlp) =>
        ({
          ...hlp,
          name: hlp.hlpNumber ? `${hlp.hlpNumber}  ${hlp.quoteDescr}` : hlp.quoteDescr,
        })))));
  }

  onClone(): void {
    if (this.input.entryPoint === HlpQuoteCloneDialogEntryPoint.CloneQuote) {
      this.hlpRest.getCloneVariations(this.form.getControl('hlp').value.id).subscribe((variations) => {
        this.dialogRef.close(variations);
      },
                                                                                      this.notificationService.processAll);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  findHlpByNumberDescription(query: FilteredDataQuery<string>, filter: any): Observable<HlpListItem[]> {
    return this.hlpRest.findAllAsDataSource({
      ...filter,
      searchString: query.filter,
    }).select(query).pipe(map$(getSlicedData));
  }

}

export const hlpQuoteCloneDataDialogRoute = createDialogRoute({
  component: HlpQuoteCloneDataDialogComponent,
  config: { autoFocus: false },
});
